import { FormControlLabel } from '@mui/material';
import { styled } from '@innowise-group/mui-kit';

export const LabelContainer = styled(FormControlLabel)`
  overflow-y: hidden;
  &.MuiFormControlLabel-root {
    margin: 0;
    gap: 3px;
    width: fit-content;
    max-width: 100%;
  }
  .MuiFormControlLabel-label {
    ${({ theme }) => theme.fonts.primary[40]};
    color: ${({ theme }) => theme.palette.general.darkGrey[100]};
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
